import { render, staticRenderFns } from "./bargainAttr.vue?vue&type=template&id=bdb37fac&scoped=true"
import script from "./bargainAttr.vue?vue&type=script&lang=js"
export * from "./bargainAttr.vue?vue&type=script&lang=js"
import style0 from "./bargainAttr.vue?vue&type=style&index=0&id=bdb37fac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb37fac",
  null
  
)

component.options.__file = "bargainAttr.vue"
export default component.exports